// d3 schemeCategory10 color palette - previously exported from d3-scale v1-v3,
// moved to d3-scale-chromatic in v4. Inlined here to avoid an extra dependency.
export const schemeCategory10 = [
  "#1f77b4", "#ff7f0e", "#2ca02c", "#d62728", "#9467bd",
  "#8c564b", "#e377c2", "#7f7f7f", "#bcbd22", "#17becf"
];
